module.exports = __webpack_public_path__ + "static/img/sidewall.693b888.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/service/sidewall.png
// module id = BkCa
// module chunks = 1